import { render } from "./GemMechanism15.vue?vue&type=template&id=19e81f65&scoped=true"
import script from "./GemMechanism15.vue?vue&type=script&lang=js"
export * from "./GemMechanism15.vue?vue&type=script&lang=js"

import "./GemMechanism15.vue?vue&type=style&index=0&id=19e81f65&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19e81f65"]])

export default __exports__